import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { switchMap } from "rxjs/operators";
import { createImageFromBlob } from "src/app/util/image";
import { Page } from "src/app/util/page";
import { InitSearch } from "../../util/search/init-search";
import { ReferenceInventoryMovement } from "../inventory-movement/reference-inventory-movement";
import { NewReferenceRequest } from "./new-reference/new-reference-request";
import { NewReferenceResponse } from "./new-reference/new-reference-response";
import { NewSupplierReferenceRequest } from "./new-supplier-reference-request";
import { NewSupplierReferenceResponse } from "./new-supplier-reference-response";
import { LoadReferenceOptions, Reference } from "./reference";
import { SearchReferenceRequest } from "./search-reference-request";

@Injectable()
export class ReferenceService {
  private referencesSubject = new Subject<InitSearch<Reference>>();

  constructor(private httpClient: HttpClient) { }

  public create(newReferenceRequest: NewReferenceRequest, options: LoadReferenceOptions): Observable<NewReferenceResponse> {
    return this.httpClient.post<NewReferenceResponse>("/api/reference", newReferenceRequest);
  }

  public createSupplierReference(request: NewSupplierReferenceRequest): Observable<NewSupplierReferenceResponse> {
    return this.httpClient.post<NewSupplierReferenceResponse>("/api/reference/supplier-reference", request);
  }

  public findByIsbn(isbn: string): Observable<Reference> {
    return this.httpClient.get<Reference>("/api/reference/" + isbn);
  }

  public findInventoryMovementByIsbn(isbn: string, page: number): Observable<Page<ReferenceInventoryMovement>> {
    return this.httpClient
      .get<Page<ReferenceInventoryMovement>>(`/api/reference/${isbn}/inventory-movement?size=10000&page=${page}&sort=creationTimestamp,DESC`);
  }

  public loadImageInReference(reference: Reference, options: LoadReferenceOptions): Observable<string | ArrayBuffer | null> {
    return this.httpClient.get("/api/reference/" + reference.isbn + "/cover?maxWidth=" + options?.imageMaxWidth, { responseType: 'blob' }).pipe(
      switchMap(blob => createImageFromBlob(blob, reference)));
  }

  public search(searchRequest: SearchReferenceRequest, page: number, options: LoadReferenceOptions): Observable<Page<Reference>> {
    return this.httpClient.post<Page<Reference>>(`/api/reference?search&page=${page}`, searchRequest);
  }

  public initSearchResult(initSearch: InitSearch<Reference>) {
    setTimeout(() => this.referencesSubject.next(initSearch));
  }

  public onReferencesRefresh(): Observable<InitSearch<Reference>> {
    return this.referencesSubject.asObservable();
  }

  public overrideRetailPrice(isbn: string, retailPriceOverride: number): Observable<void> {
    return this.httpClient.put<void>(`/api/reference/${isbn}?retailPriceOverride=${retailPriceOverride}`, null);
  }

  public switchSupplier(isbn: string, newSupplierId: string): Observable<Reference> {
    return this.httpClient.post<Reference>(`/api/reference/${isbn}?newSupplierId=${newSupplierId}`, null);
  }
}